// src/data/projectsData.js

export const projectData = [
  {
    id: "kiko-de-kikker", // Unieke ID/slug voor selectie
    title: "Kiko de Kikker",
    eas: "images/Showcase/showcase_ea_all.png",
    course: "M2.1 Preparation Final Master Project",
    grade: "Excellent (9.0)",
    experts: ["Go Wonder", "Maastricht UMC+", "Groene Hart Hospital"],
    inShort: "Hospitalized children often lack mobilization during their admission. Kiko de Kikker transforms existing mobilization exercises into playful activities using a friendly frog-themed, three-step staircase. Positioned directly at the bedside, its interactive light and sound design motivates patients to progress from basic stepping to full stair-climbing within their own room.",
    videoUrl: "https://youtu.be/sB5AIUW6lCc", // Vul hier de link in (bijv. "/videos/kiko.mp4") als die er is, anders blijft hij null
    placeholderImg: "images/Showcase/kiko_placeholder.png", // Wordt getoond als videoUrl null is
    imageCount: 6,
    
  },
  {
    id: "overdetop",
    title: "OverDeTop",
    eas: "images/Showcase/showcase_ea_all.png",
    course: "Final Master Project",
    grade: "Pending",
    experts: ["Go Wonder", "Maastricht UMC+", "Groene Hart Hospital"],
    inShort: "OverDeTop is an interactive staircase that transforms a pediatric hospital room into a playground. It empowers children to autonomously engage in daily movement outside of formal physiotherapy sessions. Through its unique shape and multi-sensory game design, the staircase naturally activates key muscle groups and stimulates activity in both single and multiplayer modes.",
    videoUrl: "https://youtu.be/akHfOtf2XMc",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 6,
  },
   {
    id: "physi",
    title: "Physi",
    eas: "images/Showcase/showcase_ea_all.png",
    course: "M1.1 Design Project",
    grade: "Excellent (9.0)",
    experts: ["Kubus Kinderfysiotherapie"],
    inShort: "Pediatric physiotherapists often lack versatile tools, which are inherently fun and playful and they rely mostly on qualitative observations. This interactive add-on for the BOSU balance trainer, called Physi, uses lights and sounds to gamify existing balancing exercises. The system collects pressure data over the feet and can therefore provide objective rehabilitation data tracking.",
    videoUrl: "https://www.youtube.com/watch?v=poaF-KZbEqo",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 9,
  },
   {
    id: "crowdcollab",
    title: "CrowdCollab",
    eas: "images/Showcase/showcase_ea_3.png",
    course: "Designing User Interfaces with Emerging Technologies",
    grade: "9.4",
    experts: null,
    inShort: "Crowd management teams are concerned with collaborative and interdisciplinary planning, but existing systems often lack means for dynamic stakeholder interaction. CrowdCollab is an interactive, table-based tangible interface complemented with an Augmented Reality experience. It allows crowd management teams to explore and experience a digital twin, fostering a shared understanding.",
    videoUrl: "https://m.youtube.com/watch?v=4zp4Lyyfjms&pp=iggCQAE%3D&ra=m",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 0,
  },
     {
    id: "torque",
    title: "TORQUE",
    eas: "images/Showcase/showcase_ea_trmdc.png",
    course: "M1.2 Research Project",
    grade: "Excellent (9.0)",
    experts: null,
    inShort: "Remote human-robot interactions require precise control and situational awareness. This project therefore explores how different levels of force feedback affect task performance and user experience for arc-welding robots. By evaluating submissive, assistive, and dominant haptic feedback, it researches trajectory adherence and spatial understanding.",
    videoUrl: null,
    placeholderImg: "images/Showcase/torque/torque.png",
    imageCount: 5,
  },
   {
    id: "vitalflow",
    title: "VitalFlow",
    eas: "images/Showcase/showcase_ea_3.png",
    course: "Data-Enabled Design",
    grade: "8.8",
    experts: null,
    inShort: "During this process, we got introduced to the Data-Enabled Design process, which was leveraged to employ a non-judgemental interface for breathing tracking. Through the development of custom breathing sensors and real-time data physicalizations, we have been able to derive contextual insights around breathing focusing on open-ended explorations, rather than forced behavior change.`",
    videoUrl: "https://www.youtube.com/watch?v=n4n1g4I1Kg8",
    placeholderImg: "images/Showcase/vitalflow/vitalflow.png",
    imageCount: 6,
  },
     {
    id: "microfluidics",
    title: "Microfluidic valve",
    eas: "images/Showcase/showcase_ea_tr.png",
    course: "Microfabrication Methods",
    grade: "7.0",
    experts: null,
    inShort: "During this project, we developed a pneumatic bowl valve to regulate fluid flow in microchannels with as little delamination or leakage as possible. The valve itself was constructed using a flexible PDMS membrance in a blocking face-on architecture. Overall, this project confirmed the feasibility of pneumatic actuation for a reliable, scalable microfluidic valve.",
    videoUrl: null,
    placeholderImg: "images/Showcase/microfluidics/valve.png",
    imageCount: 9,
  },
    {
    id: "bouwplaats",
    title: "Bouwplaats",
    eas: "images/Showcase/showcase_ea_all.png",
    course: "Final Bachelor Project",
    grade: "Excellent (9.0)",
    experts: ["Municipality of Eindhoven"],
    inShort: "De Bouwplaats is an augmented reality citizen participation tool, which was developed in collaboration with the municipality of Eindhoven for the KnoopXL project. Users can adjust procedural city generation using sliders in a VR experience. This experience aims to spar discussions about urban preferences to engage them in discussions with city planners.",
    videoUrl: "https://youtu.be/wGcpey9GNAU",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 0
  },
     {
    id: "buto",
    title: "Hajraa Outdoor 2025",
    inShort: "Hajraa Outdoor is Europe’s largest outdoor volleyball tournament and festival. As the PR responsible, I was in charge of the communication strategy to promote the event: designing promotion material, managing social media channels and being the first contact with tournament visitors. During the tournament I managed the promotion team, responsible for documenting and editing photos and videos for the tournament.",
    videoUrl: "https://www.youtube.com/watch?v=g7kRHDS38E0",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 3,
  },
   {
    id: "tuecontest",
    title: "TU/e Contest 2026",
    inShort: "The TU/e Contest is an annual innovation competition where student teams develop and pitch innovative solutions for real-world challenges. I entered the competition with my Final Master Project to get into contact with market experts and strengthen my overall narrative. Eventually I was able to secure various prizes because of the viability and maturity of the project.",
    videoUrl: "https://www.youtube.com/watch?v=1XacQSu2F-8&list=PLk-3q_Ea7-TPdEB7mUGHiz5JEuxLb8ALY&index=13",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 0
  },
  {
    id: "ignite",
    title: "Team IGNITE: Wayfinding",
    inShort: "As Technology Designer for Team IGNITE, I was responsible for one of their projects; Wayfinding, which was part of 2024’s GLOW route. The system embodied an illuminated acrylic structure that uses custom developed LED strips and custom developed connection parts to secure a string of these structures over a large distance over water. ",
    videoUrl: "https://www.youtube.com/watch?v=zIlGxrKHRZ8",
    placeholderImg: "images/Showcase/odt_placeholder.png",
    imageCount: 0
  },
];